export const MENU_LIST_REQUEST = "MENU_LIST_REQUEST";
export const MENU_LIST_SUCCESS = "MENU_LIST_SUCCESS";
export const MENU_LIST_FAILURE = "MENU_LIST_FAILURE";

export const MENU_ITEM_UPDATE_REQUEST = "MENU_ITEM_UPDATE_REQUEST";
export const MENU_ITEM_UPDATE_SUCCESS = "MENU_ITEM_UPDATE_SUCCESS";
export const MENU_ITEM_UPDATE_FAILURE = "MENU_ITEM_UPDATE_FAILURE";
